<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <terms-tap :tab="tab"></terms-tap>
        <div class="area_wrap">
          <div class="terms_box">
            <div class="tb_mainTitle">
              <h2>땡큐서울의원의원 서비스 이용약관</h2>
              <h2>제1장 총칙</h2>
            </div>
            <div class="tb_item">
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제1조 (목적)</h2>
                </div>
                <div class="tb_text">
                  <p>땡큐서울의원의원(이하 ‘의원’이라 한다)에서 운영하는 인터넷 관련 서비스(홈페이지/모바일 웹, 앱)
                    (이하 ‘서비스’라 한다)의 이용에 관한 사항을 규정함을 목적으로 합니다.</p>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제2조 (정의)</h2>
                </div>
                <div class="tb_text">
                  <div class="normalNum">
                    <h2>이용자(회원) : 땡큐서울의원의원에서 운영하는 인터넷 관련 서비스(홈페이지/모바일 웹, 앱)에 로그인하여
                      본 약관에 따라 의원이 제공하는 서비스를 받는 자를 말합니다.</h2>
                    <h2>운영자 : 서비스의 전반적인 관리와 원활한 운영을 위하여 의원에서 선정한 사람</h2>
                    <h2>연결사이트 : 땡큐서울의원의원에서 운영하는 인터넷 관련 서비스
                      (홈페이지/모바일 웹, 앱)와 하이퍼링크 방식(하이퍼링크의 대상에는 문자, 정지 및 동화상 등이 포함됨)
                      등으로 연결된 웹 사이트를 말합니다.</h2>
                    <h2>개인정보 : 당해 정보에 포함되어 있는 성명, 아이디 등의 사항에 의하여
                      특정 개인을 식별할 수 있는 정보(당해 정보만으로는 특정 개인을 인식할
                      수 없더라도 다른 정보와 용이하게 결합하여 식별할 수 있는 것을 포함한다)를 말합니다.</h2>
                    <h2>해지 : 이용자가 서비스 개통 후 이용계약을 해약(회원 탈퇴) 하는 것</h2>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제3조 (약관의 게시 및 변경)</h2>
                </div>
                <div class="tb_text">
                  <div class="normalNum">
                    <h2>의원은 본 약관의 내용과 상호, 의원 소재지, 전자우편 주소 등을 이용자가
                      알 수 있도록 땡큐서울의원의원 인터넷 관련 서비스(홈페이지/
                      모바일 웹, 앱)에 게시합니다.</h2>
                    <h2>의원은 불가피한 사정이 있는 경우 관계 법령을 위배하지 않는 범위에서
                      본 약관을 개정할 수 있습니다.</h2>
                    <h2>의원은 약관을 개정할 경우에는 전항과 같은 방법으로 공지 또는 통보함으로써 효력을 발생합니다.</h2>
                    <h2>이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 관계 법령
                      또는 상 관례에 따릅니다.</h2>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제4조 (서비스의 내용 및 변경)</h2>
                </div>
                <div class="tb_text">
                  <div class="normalNum">
                    <h2>의원은 다음의 서비스를 제공합니다.</h2>
                    <div class="num">
                      <h2>의원의 의료진 및 진료 일정 안내</h2>
                      <h2>의원 또는 연결사이트를 통해 제공되는 예약, 제증명 발급, 검사결과 조회
                        서비스</h2>
                      <h2>의원에서 제공하는 정보 및 건강 관련 콘텐츠</h2>
                      <h2>기타 의원이 정하는 서비스</h2>
                    </div>
                    <h2>의원은 불가피한 사정이 있는 경우 제공하는 서비스의 내용을 변경할 수
                      있으며, 이 경우 변경된 서비스의 내용 및 제공 일자를 명시하여
                      그 제공일자 이전 7일부터 공지합니다.</h2>
                    <h2>의원은 서비스 내용의 변경으로 인하여 이용자가 입은 손해에 대하여 배상하지 아니합니다.
                      단, 의원의 고의 또는 중과실이 있는 경우에는 그러하지 아니합니다.</h2>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제5조 (서비스의 중단)</h2>
                </div>
                <div class="tb_text">
                  <div class="normalNum">
                    <h2>의원은 시스템 등 장치의 보수점검·교체 및 고장, 통신의 두절,
                      기타 불가항력적 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수
                      있습니다.</h2>
                    <h2>의원은 제1항의 사유로 서비스 제공이 일시적으로 중단됨으로 인하여
                      이용자 또는 제3자가 입은 손해에 대하여는 배상하지 아니합니다.
                      단, 의원의 고의 또는 중과실이 있는 경우에는 그러하지 아니합니다.</h2>
                  </div>
                </div>
              </div>
              <div class="tb_mainTitle pt-20">
                <h2>제2장 회원의 가입 및 탈퇴</h2>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제6조 (회원 가입)</h2>
                </div>
                <div class="tb_text">
                  <div class="normalNum">
                    <h2>이용자는 의원의 정한 양식에 따라 회원 정보를 기입한 후
                      본 약관에 동의한다는 의사표시를 함으로써 회원 가입을 신청합니다.</h2>
                    <h2>의원은 전항과 같이 회원으로 가입할 것을 신청한 이용자 중 이하 각호에
                      해당하지 않는 한 회원으로 등록합니다.</h2>
                      <div class="num">
                        <h2>가입 신청자가 본 약관 제7조 제2항에 의거하여 이전에 회원자격을 상실한
                          적이 있는 경우</h2>
                        <h2>등록내용에 허위, 기재 누락, 오기가 있는 경우</h2>
                        <h2>기타 회원으로 등록하는 것이 의원의 기술상 또는 업무 수행상 현저히 지장이 있다고 판단하는 경우</h2>
                      </div>
                    <h2>회원 가입 계약의 성립 시기는 의원이 승낙한 시점으로 합니다.</h2>
                    <h2>회원은 등록사항에 변경이 있는 경우, 즉시 전화 또는 기타 방법으로 의원에 그 변경사항을 알려야 합니다.</h2>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제7조 (회원 탈퇴 및 자격의 상실 등)</h2>
                </div>
                <div class="tb_text">
                  <div class="normalNum">
                    <h2>회원은 의원에 언제든지 탈퇴를 요청할 수 있으며 의원은 즉시 회원 탈퇴를 처리합니다.
                      단, 탈퇴의 요청은 땡큐서울의원의원 인터넷 관련
                      서비스(홈페이지/모바일 웹, 앱)를 이용하여야 하며, 요청하는 자의 이름,
                      전화번호, 해지사유 등을 기재하여야 합니다.</h2>
                    <h2>회원이 다음 각호의 사유에 해당하는 경우, 의원은 회원자격을 상실시킬
                      수 있습니다.</h2>
                  </div>
                  <div class="num">
                    <h2>등록 신청 시에 허위 내용을 등록한 경우</h2>
                    <h2>다른 사람의 서비스 이용을 방해하거나 그 정보를 도용하는 등 질서를
                      위협하는 경우의원 내에서 검증되지 않은 허위정보 및 기타 허락되지 않은 물품의 판매 행위를 하는 경우</h2>
                    <h2>의원 내에서 허락되지 않은 진료행위 또는 진료행위를 위한 선전의 장소로 이용하는 경우</h2>
                    <h2>의원 내에 제공되는 정보를 변경하는 등 땡큐서울의원의원 인터넷
                      관련 서비스(홈페이지/모바일 웹, 앱) 운영을 방해한 경우</h2>
                    <h2>의원을 이용하여 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를
                      하는 경우</h2>
                    <h2>본 약관을 위반한 경우</h2>
                    <h2>기타 회원으로서의 자격을 지속시키는 것이 부적절하다고 판단되는 경우</h2>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제8조 (회원에 대한 통지)</h2>
                </div>
                <div class="tb_text">
                  <div class="normalNum">
                    <h2>의원은 회원에 대한 통지를 하는 경우, 회원이 의원에 제공한
                      전자우편 주소 또는 전화번호로 할 수 있습니다.</h2>
                    <h2>의원은 불특정다수 회원에 대한 통지의 경우 게시판에 게시함으로써 개별
                      통지에 갈음할 수 있습니다.</h2>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제9조 (진료 예약의 신청 및 성립)</h2>
                </div>
                <div class="tb_text">
                  <div class="normalNum">
                    <h2>이용자는 땡큐서울의원의원 인터넷 관련 서비스(홈페이지/모바일
                      웹, 앱)상에서 이하의 방법에 의하여 진료 예약을 신청합니다.</h2>
                  <div class="num">
                    <h2>휴대폰 번호(본인인증), 비밀번호, 성명 등의 개인정보 입력</h2>
                    <h2>진료과, 의료진, 예약일시 선택</h2>
                    <h2>이 약관에 동의한다는 표시</h2>
                  </div>
                    <h2>의원은 제1항의 예약신청에 대하여 다음 각호의 사유에 해당하지 않는 한
                      승낙합니다.</h2>
                    <div class="num">
                      <h2>신청 내용에 허위, 기재 누락, 오기가 있는 경우</h2>
                      <h2>기타 예약신청에 승낙하는 것이 기술상 또는 진료일정상 현저히 지장이 있다고 판단하는 경우</h2>
                    </div>
                    <h2>이용자가 인터넷 관련 서비스로 예약 신청하는 경우에는 아래에 사항에
                      이해하고 동의하는 것으로 간주합니다.</h2>
                    <div class="num">
                      <h2>인터넷 관련 서비스를 통한 예약 확인, 취소 및 변경은 인터넷 관련 서비스를 통해 성립된 예약에 한합니다.</h2>
                      <h2>내원이나 전화를 통한 예약을 인터넷 관련 서비스로 확인하기 위해서는 별도의 신청이 필요합니다.</h2>
                      <h2>진료 예약 변경 및 취소는 진료일 이전 자정까지 신청할 수 있습니다. 예약
                        취소 없이 의원을 방문하지 않는 경우가 3회 누적되면, 인터넷 관련 서비스를
                        통한 예약 서비스가 차단될 수 있습니다.</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tb_mainTitle pt-20">
                <h2>제3장 개인정보의 보호</h2>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제10조 (개인정보의 수집)</h2>
                </div>
                <div class="tb_text">
                  <div class="normalNum">
                    <h2>의원은 이용자의 정보수집 시 필요한 최소한의 정보를 수집합니다. 다음
                      사항을 필수 사항으로 하며 그 외 사항은 선택사항으로 합니다.</h2>
                    <div class="dot">
                      <p>일반 회원 가입 시 수집 항목</p>
                      <span>성명, 아이디, 비밀번호, 성별, 생년월일, 휴대전화 번호, 이메일</span>
                      <p>예비 회원 가입 시 수집 항목</p>
                      <span>성명, 아이디, 비밀번호, 성별, 생년월일, 이메일</span>
                    </div>
                    <h2>이용자의 개인정보를 수집하는 때에는 이하 각호의 경우를 제외하고는 당해 이용자의 동의를 받습니다.</h2>
                    <div class="num">
                      <h2>법률에 특별한 규정이 있는 경우</h2>
                      <h2>서비스이용계약의 이행을 위해서 필요한 경우</h2>
                      <h2>서비스의 제공에 따른 요금 정산을 위하여 필요한 경우</h2>
                    </div>
                    <h2>의원은 개인정보의 보호를 위하여 관리자를 한정하여 그 수를 최소화하며
                      개인정보의 분실, 도난, 유출, 변조되지 아니하도록 안정성 확보에 필요한
                      기술적 조치 등을 마련합니다.</h2>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제11조(개인정보의 수집목적 및 이용 목적)</h2>
                </div>
                <div class="tb_text">
                  <div class="num">
                    <h2>홈페이지 회원 가입 및 관리</h2>
                    <p>회원 가입 의사 확인, 회원제 서비스 제공에 따른 본인 식별.인증, 회원자격
                      유지.관리, 제한적 본인 확인제 시행에 따른 본인확인,
                      서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인,
                      각종 고지 및 통지, 고충 처리 등을 목적으로 개인정보를 처리합니다.</p>
                    <h2>재화 또는 서비스 제공</h2>
                    <p>서비스 제공, 콘텐츠 제공, 맞춤 서비스 제공, 본인인증, 연령인증 등을 목적
                      으로 개인정보를 처리합니다.</p>
                    <h2>진료 서비스 제공</h2>
                    <div class="dot">
                      <p>진료 및 치료를 위한 진료 서비스와 진료비 청구, 수납, 환급 등의 원무
                        서비스 제공</p>
                      <p>진료 예약 및 검사 예약 일정에 대한 고지 서비스</p>
                      <p>진료 및 업무, 교육, 연구, 통계, 환자 서비스에 필요한 최소한의 분석 자료</p>
                      <p>진료 의뢰 또는 회송병원 의료인이 진료를 위한 목적으로 요청 시 진료
                        정보 제공</p>
                      <p>기타 진료와 관련된 서비스</p>
                      <p>진료 예약, 예약 조회, 검사결과 조회, 제증명 발급 신청, 수술 관리 등
                        홈페이지 회원제 서비스 제공</p>
                      <p>진료 예약, 예약 조회 및 기타 진료 서비스 이용에 따른 본인확인과 안내 절차에 사용</p>
                      <p>진료 및 업무, 교육, 연구, 통계, 환자 서비스에 필요한 최소한의 분석 자료로 활용</p>
                      <p>외부 수탁 검사를 위한 자료</p>
                      <p>신규 서비스 개발과 개인 맞춤 서비스 제공을 위한 자료</p>
                      <p>소비자기본법 제52조에 의거한 소비자 위해 정보수집</p>
                      <p>홈페이지의 원활한 운영 및 통계분석자료로 활용</p>
                      <p>기타 진료와 관련된 서비스</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제12조(개인정보의 보유 기간 및 이용 기간)</h2>
                </div>
                <div class="tb_text">
                  <div class="normalNum">
                    <h2>홈페이지 및 모바일앱 회원 정보의 경우 회원 탈퇴 시까지 보유하고 해지
                      후에는 DB에서 삭제하고 보유하지 않습니다. 또한 개인정보가 제3자에게
                      제공된 경우에는 제3자에게 파기하도록 지시합니다. 단, 다음 각호의 경우에는
                      각호에 명시한 기간 동안 개인정보를 보유합니다.</h2>
                  </div>
                  <div class="num">
                    <h2>보유 기간을 회원에게 미리 고지하고 그 보유 기간이 경과하지 아니한 경우와
                      개별적으로 회원의 동의를 받을 경우에 약속한 보유 기간 동안 개인정보를 보유합니다.</h2>
                    <h2>수집목적 또는 제공받은 목적이 달성된 경우에도 상법 등 법령의 규정에 의해 보존할 필요성이 있는 경우에 개인정보를 보유합니다.</h2>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제13조(개인정보의 이용 및 제공의 제한)</h2>
                </div>
                <div class="tb_text">
                  <p>제공된 개인정보는 당해 이용자의 동의 없이 목적 외 이용이나 제3자에게 제공할 수 없으며,
                    이에 따른 이용자의 피해에 대한 모든 책임은 의원이 집니다. 단,
                    다음의 경우에는 예외로 합니다.</p>
                  <div class="normalNum">
                    <h2>법률에 특별한 규정이 있는 경우</h2>
                    <h2>서비스의 제공에 따른 요금 정산 및 배송 등을 위하여 필요한 경우</h2>
                    <h2>통계작성·학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을
                      식별할 수 없는 형태로 제공하는 경우</h2>
                    <h2>정보통신서비스제공자로부터 이용자의 개인정보를 제공받은 자는 당해
                      이용자의 동의가 있거나 다른 법률에 특별한 규정이 있는 경우</h2>
                    <p>위 사항을 제외하고는 개인정보를 제공받은 목적 외의 용도로 이를 이용하거나
                      제3자에게 제공하여서는 안 됩니다.</p>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제14조(이용자의 권리)</h2>
                </div>
                <div class="tb_text">
                  <div class="normalNum">
                    <h2>이용자는 언제든지 제10조 제2항, 제14조 제1항 또는 동조 제2항의 규정에 의한 동의를 철회할 수 있습니다.
                      단, 철회의 의사표시는 의원 또는 의원으로부터 정보를 제공받은 자에게 정보가 도달된 때로부터 유효합니다.</h2>
                    <h2>이용자는 의원에게 자신의 개인정보에 대한 열람을 요구할 수 있으며,
                      자신의 개인정보에 오류가 있는 경우에는 그 정정을 요구할 수 있습니다.</h2>
                    <h2>제1항 및 제2항에 의한 철회, 열람, 정정의 요구는 의원에 전자우편을
                      보내는 방식으로 하여야 하며, 의원은 전자우편이 도달된 후 지체없이 필요한 조치를 취할 의무를 집니다.
                      이용자가 오류의 정정을 요구한 경우에는 의원이 그 오류를 정정할 때까지 당해 개인정보를 이용하지 않습니다.</h2>
                  </div>
                </div>
              </div>
              <div class="tb_mainTitle pt-20">
                <h2>제4장 서비스에 관한 책임의 제한</h2>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제15조 (건강상담서비스)</h2>
                </div>
                <div class="tb_text">
                  <div class="normalNum">
                    <h2>의원은 이용자의 상담 내용이 상담 의사를 제외한 제3자에게 유출되지 않도록 최선을 다해 보안을 유지하려고 노력합니다.
                      다만, 다음 각호의 사유로 인하여 상담 내용이 공개 또는 훼손된 경우 의원은 책임을 지지 않습니다.</h2>
                    <div class="num">
                      <h2>사용자의 부주의로 비밀번호가 유출된 경우</h2>
                      <h2>사용자가 '상담 삭제' 기능을 사용한 경우</h2>
                      <h2>천재지변 등 기타 불가항력에 의한 경우</h2>
                    </div>
                    <h2>이용자의 상담 요청에 대한 종합적이고 적절한 답변을 위하여 상담 의사들은 상담 내용과 답변을 참고할 수 있습니다.</h2>
                    <h2>서비스에서 진행된 상담의 내용은 특정 개인을 식별할 수 없는 형태로 다음과 같은 목적으로 사용할 수 있습니다.</h2>
                    <div class="num">
                      <h2>학술 활동</h2>
                      <h2>인쇄물, CD-ROM 등의 저작 활동</h2>
                      <h2>FAQ 등의 서비스 내용의 일부</h2>
                    </div>
                    <h2>상담에 대한 답변 내용은 각 전문 의사의 의학적 지식을 바탕으로 한
                      주관적인 답변으로 의원의 공식적인 의견이 될 수 없으며, 상담 내용에 대하여
                      의원은 일체의 책임을 지지 않습니다.</h2>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제16조 (건강 관련 정보 제공 서비스)</h2>
                </div>
                <div class="tb_text">
                  <div class="normalNum">
                    <h2>의원에서 제공하는 건강 관련 정보는 개략적이며 일반적인 것으로서
                      특정인의 의견에 지나지 않으며 어떠한 경우에도 전문적인 의학적 진단, 진료,
                      치료를 대신할 수 없습니다.</h2>
                    <h2>의원은 건강 관련 정보제공서비스에서 언급된 어떠한 특정한 검사나 제품
                      또는 치료법을 보증하지 않습니다.</h2>
                    <h2>의원은 제공하는 건강 관련 정보는 전적으로 이용자의 판단에 따라 이용되는 것으로서,
                      의원은 건강 관련 정보의 제공과 관련하여 어떠한 책임도 지지 않습니다.</h2>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제17조 (의원과 연결사이트 간의 관계)</h2>
                </div>
                <div class="tb_text">
                  <p>의원은 연결사이트가 독자적으로 제공하는 재화, 용역, 서비스에 의하여
                    이용자와 행하는 거래에 대해서 어떠한 보증책임을 지지 않습니다.</p>
                </div>
              </div>
              <div class="tb_mainTitle pt-20">
                <h2>제5장 의원 및 이용자의 의무</h2>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제18조 (의원의 의무)</h2>
                </div>
                <div class="tb_text">
                  <div class="normalNum">
                    <h2>의원은 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며
                      본 약관이 정하는 바에 따라 지속적이고, 안정적으로 서비스를 제공하는 데 최선을 다합니다.</h2>
                    <h2>의원은 이용자의 신용정보를 포함한 개인신상정보의 보안에 대하여 기술적 안전 조치를 마련하고
                      관리에 만전을 기함으로써 이용자의 정보보안에
                      최선을 다합니다.</h2>
                    <h2>의원은 공정하고 건전한 운영과 지속적인 연구·개발을 통하여 양질의 서비스를 제공함으로써
                      고객 만족을 극대화하여 인터넷 비즈니스 발전에 기여하도록 합니다.</h2>
                    <h2>의원은 이용자가 원하지 않는 영리 목적의 광고성 전자우편을 발송하지
                      않습니다.</h2>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제19조 (이용자의 주민등록번호 및 비밀번호에 대한 의무)</h2>
                </div>
                <div class="tb_text">
                  <div class="normalNum">
                    <h2>이용자는 진료 예약 서비스를 이용하는 경우 휴대폰번호(본인인증) 및
                      비밀번호를 사용해회원가입 및 로그인을 하여야 합니다.</h2>
                    <h2>이용자의 개인정보와 비밀번호에 관한 모든 관리의 책임은 이용자에게 있습니다.</h2>
                    <h2>이용자는 자신의 개인정보 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다.</h2>
                    <h2>이용자의 개인정보 및 비밀번호 관리의 부실로 인한 모든 책임은 이용자
                      가 부담합니다.</h2>
                    <h2>이용자는 개인정보 및 비밀번호를 도난당하거나 제3자에게 사용되고 있음을
                      인지한 경우에는 바로 의원에 통보하고 의원의 안내가 있는 경우에는 그에 따라야 합니다.</h2>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제20조 (이용자의 의무)</h2>
                </div>
                <div class="tb_text">
                  <div class="normalNum">
                    <h2>이용자는 다음의 행위를 하여서는 안 됩니다.</h2>
                    <div class="dot">
                      <p>의원에 게시된 정보의 변경</p>
                      <p>의원이 정한 정보 이외의 정보(컴퓨터프로그램 등) 송신 또는 게시</p>
                      <p>의원 기타 제3자의 저작권 등 지적 재산권에 대한 침해</p>
                      <p>의원 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</p>
                      <p>외설 또는 폭력적인 메시지·화상·음성 기타 공서양속에 반하는 정보를</p>
                      <p>의원에 공개 또는 게시하는 행위</p>
                      <p>다른 이용자에 대한 건강진료 및 상담을 하거나 알선하는 행위</p>
                      <p>제3자의 진료행위를 선전하는 행위</p>
                      <p>상품을 판매하거나 판매를 알선하는 행위</p>
                    </div>
                    <h2>전항 각호의 정보 또는 기타 의원이 사이트 운영상 부적절하다고 판단한
                      정보가 의원의 서비스(홈페이지/모바일 웹, 앱)에 게시되거나 사이트와 링크된 곳에 게시된 경우,
                      의원은 이용자 또는 기타 정보의 게시를 행한 자의 승낙 없이
                      의원의 서비스에 게재된 당해 정보를 삭제하거나 링크를 단절할 수 있습니다.
                      단, 의원은 이러한 정보의 삭제·링크의 절단 등을 할 의무를 지지 않습니다.</h2>
                  </div>
                </div>
              </div>
              <div class="tb_mainTitle pt-20">
                <h2>제6장 기타</h2>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제21조 (저작권의 귀속 및 이용제한)</h2>
                </div>
                <div class="tb_text">
                  <div class="normalNum">
                    <h2>의원은 작성한 저작물에 대한 저작권 기타 지적 재산권은 의원에 귀속합니다.</h2>
                    <h2>이용자는 땡큐서울의원의원 인터넷 관련 서비스(홈페이지/모바일
                      웹, 앱)을 이용함으로써 얻은 정보를 의원의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여
                      영리 목적으로 이용하거나 제3자에게
                      이용하게 하여서는 안 됩니다.</h2>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제22조 (분쟁해결)</h2>
                </div>
                <div class="tb_text">
                  <div class="normalNum">
                    <h2>본 이용약관에 규정된 것을 제외하고 발생하는 서비스 이용에 관한 제반
                      문제에 관한 분쟁은 최대한 쌍방 합의에 의해 해결하도록 합니다.</h2>
                    <h2>이용자가 땡큐서울의원의원 인터넷 관련 서비스(홈페이지/모바일
                      웹, 앱) 이용과 관련하여 불만이 있거나 의견을 제시하고자 하는 경우에는
                      전자우편 또는 전화로 땡큐서울의원의원 인터넷 관련 서비스(홈페이지/모바일 웹, 앱)에 대한
                      불만 사항 또는 의견을 제출하면 됩니다.</h2>
                    <h2>의원은 이용자로부터 제출되는 불만 사항 및 의견이 정당하다고 판단하는
                      경우 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는
                      이용자에게 그 사유와 처리 일정을 즉시 통보해 드립니다.</h2>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제23조 (재판권 및 준거법)</h2>
                </div>
                <div class="tb_text">
                  <p>의원과 이용자 간에 서비스 이용으로 발생한 분쟁에 관한 소송은 민사소송법상의 관할법원으로 합니다.</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
<!--      <div class="btnWrap visible" @click="agree()">-->
<!--        <button type="button" class="callTerms">확인</button>-->
<!--      </div>-->
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import TermsTap from '@/components/TermsTap'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      tab: {
        second: true
      },
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '회원약관',
        prevUrl: '/login'
      },
      setCount: false
    }
  },
  computed: {
    ...mapGetters([

    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapActions([
    ]),
    agree () {
      this.$router.push('/login')
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/login')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup,
    TermsTap
  },
  beforeDestroy () {
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
</style>
